"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_resolve_hypermedia_1 = require("@comunica/bus-rdf-resolve-hypermedia");

var RdfSourceQpf_1 = require("./RdfSourceQpf");
/**
 * A comunica QPF RDF Resolve Quad Pattern Actor.
 */


var ActorRdfResolveHypermediaQpf =
/*#__PURE__*/
function (_bus_rdf_resolve_hype) {
  _inherits(ActorRdfResolveHypermediaQpf, _bus_rdf_resolve_hype);

  function ActorRdfResolveHypermediaQpf(args) {
    _classCallCheck(this, ActorRdfResolveHypermediaQpf);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfResolveHypermediaQpf).call(this, args, 'qpf'));
  }

  _createClass(ActorRdfResolveHypermediaQpf, [{
    key: "testMetadata",
    value: function () {
      var _testMetadata = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var searchForm;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                searchForm = this.createSource(action.metadata, action.context, null).searchForm;

                if (searchForm) {
                  _context.next = 3;
                  break;
                }

                throw new Error("Actor ".concat(this.name, " could not detect a TPF/QPF search form."));

              case 3:
                if (!(action.handledDatasets && action.handledDatasets[searchForm.dataset])) {
                  _context.next = 5;
                  break;
                }

                throw new Error("Actor ".concat(this.name, " can only be applied for the first page of a QPF dataset."));

              case 5:
                return _context.abrupt("return", {
                  filterFactor: 1
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testMetadata(_x) {
        return _testMetadata.apply(this, arguments);
      }

      return testMetadata;
    }()
    /**
     * Look for the search form
     * @param {IActionRdfResolveHypermedia} the metadata to look for the form.
     * @return {Promise<IActorRdfResolveHypermediaOutput>} A promise resolving to a hypermedia form.
     */

  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var source;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.logInfo(action.context, "Identified as qpf source: ".concat(action.url));
                source = this.createSource(action.metadata, action.context, action.quads);
                return _context2.abrupt("return", {
                  source: source,
                  dataset: source.searchForm.dataset
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "createSource",
    value: function createSource(metadata, context, quads) {
      return new RdfSourceQpf_1.RdfSourceQpf(this.mediatorMetadata, this.mediatorMetadataExtract, this.mediatorRdfDereference, this.subjectUri, this.predicateUri, this.objectUri, this.graphUri, metadata, context, quads);
    }
  }]);

  return ActorRdfResolveHypermediaQpf;
}(bus_rdf_resolve_hypermedia_1.ActorRdfResolveHypermedia);

exports.ActorRdfResolveHypermediaQpf = ActorRdfResolveHypermediaQpf;